module.exports = __webpack_public_path__ + "img/colors.589c14b4.webp";